import { AppDispatch } from "app/configure.store";
import { CLOSE_ALL_OVERLAYS, CLOSE_SEARCH_OVERLAY } from "layout/redux/overlay.actions";

export default (elementRef: any) => async (dispatch: AppDispatch) => {
    try {
        // Animate an outro using CSS animations
        dispatch({
            type: CLOSE_SEARCH_OVERLAY
        });

        // Cleanup after the element has made its outro
        elementRef.current.addEventListener("animationend", () => {
            dispatch({
                type: CLOSE_ALL_OVERLAYS
            });
        });
    }
    catch { }
};